<template>
    <div class="config-competitor-one">
        <div class="config-competitor-card rounder-8 mb-4">
            <!-- Header -->
            <div class="product-info-header mb-3">
                <span class="product-sku-badge">{{ propHead.row.product_sku }}</span>
                <span class="product-name-text">{{ propHead.row.product_name }}</span>
                Cliente:{{ this.authentication_user.client_name }} y business {{ this.authentication_user.client_business_select }}
            </div>

            <!-- 4 tarjetas de posicionamiento -->
            <div class="position-cards-grid mb-4">
                <div 
                    v-for="option in positioningOptions" 
                    :key="option.value"
                    class="position-card"
                    :class="{ 'position-card--active': propHead.row.rule === option.value }"
                    @click="propHead.row.rule = option.value"
                >
                    <div class="position-card-icon">
                        <font-awesome-icon :icon="['fas', option.icon]" />
                    </div>
                    <div class="position-card-title">{{ option.title }}</div>
                    <div class="position-card-desc">{{ option.desc }}</div>
                </div>
            </div>

            <!-- Diferencial -->
            <div 
                class="mb-4 w-100"
                v-if="propHead.row.rule != 1 && propHead.row.rule != 3"
            >
                <label class="form-label fw-600 size-13 text-secondary mb-2">DIFERENCIAL FRENTE AL PRECIO DE MERCADO</label>
                <div class="input-group">
                    <input 
                        type="number" 
                        class="form-control fw-600 size-16" 
                        v-model.number="propHead.row.value"
                        step="0.001"
                        min="0"
                        @keydown="onKeyDownPercent"
                        @input="formartPorcent"
                    />
                    <span class="input-group-text bg-light border-start-0 text-secondary fw-500">% vs. mercado</span>
                </div>
                <small class="text-secondary size-12 mt-1 d-block">Formato decimal: 0.500 = 50%, 0.990 = 99%</small>
            </div>

            <!-- Competidor de referencia -->
            <div class="competitor-section">
                <span class="competitor-badge">{{ propHead.row.competitor_name }}</span>
            </div>

            <!-- SKU Competidor interno (solo si es competidor interno) -->
            <div class="internal-competitor-section mt-4" v-if="isInternalCompetitor(propHead.row.competitor_name)">
                <label class="form-label fw-600 size-13 text-secondary mb-2">SKU COMPETIDOR INTERNO</label>
                <input 
                    type="text" 
                    class="form-control fw-500 size-14" 
                    v-model="propHead.row.codex_product_competitor"
                    placeholder="Ingresa el SKU del competidor interno"
                />
            </div>
        </div>

        <!-- Botones de acción -->
        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-success fw-400 px-4" @click="saveCompetitor" :disabled="saving">
                <span v-if="saving">Guardando...</span>
                <span v-else>Guardar</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import competitorInternalMixin from './mixins/competitorInternalMixin';

const POSITIONING_OPTIONS = [
    { value: 0, title: 'Por debajo del mercado', desc: 'Precio agresivo, ganar volumen', icon: 'arrow-down' },
    { value: 1, title: 'Paridad con mercado', desc: 'Alineado a la competencia', icon: 'balance-scale' },
    { value: 2, title: 'Por encima del mercado', desc: 'Premium / diferenciación', icon: 'arrow-up' },
    { value: 3, title: 'Precio fijo', desc: 'No se mueve por competidor', icon: 'lock' },
];

export default {
    name: 'config-competitor-update-one',
    mixins: [competitorInternalMixin],
    props: {
        propHead: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            positioningOptions: POSITIONING_OPTIONS,
            saving: false,
            client_competitor: [],
        };
    },
    methods: {
        ...mapActions(['update']),
        saveCompetitor() {
            this.saving = true;
            const row = this.propHead.row;
            const isInternal = this.isInternalCompetitor(row.competitor_name);
            const data = {
                id: row.id,
                product: row.product,
                rule: row.rule,
                value: (row.rule == 1) ? 0 : row.value,
                client_competitor: this.propHead.row.client_competitor,
                codex_product_competitor: isInternal ? (row.codex_product_competitor || null) : null,
                convert:null,
                unit_convert: null,
                business: this.authentication_user.client_business_select || null,
            };
            this.update({
                url: `/api/pricescrapingrules/update_policies/`,
                params: data,
            }).then(() => {
                this.saving = false;
                this.$emit('refrest');
                this.$notification.success('Configuración de competidor actualizada correctamente.', { timer: 5, showCloseIcn: true });
            }).catch((error) => {
                this.saving = false;
                if (error.status == 400) {
                    this.$notification.error(error.data.message || 'Error al guardar la configuración.', { timer: 5, showCloseIcn: true });
                } else {
                    this.$notification.error('Error al guardar la configuración.', { timer: 5, showCloseIcn: true });
                }
            });
        },
        onKeyDownPercent(event) {
            if (event.key === '-') {
                event.preventDefault();
            }
        },
        formartPorcent(event) {
            const rawValue = event.target.value;
            const sanitizedValue = String(rawValue).replace(/[^0-9.]/g, '');
            const parsedValue = parseFloat(sanitizedValue);

            if (!isNaN(parsedValue)) {
                let value = parsedValue;
                if (value > 1) {
                    value = value / 100;
                }
                this.propHead.row.value = Number(value.toFixed(3));
            } else {
                this.propHead.row.value = 0;
            }
        },
    }
};
</script>

<style scoped>
.config-competitor-card {
    background: #ffffff;
}

.product-info-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
}

.product-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 4px;
    white-space: nowrap;
}

.product-name-text {
    font-size: 0.9rem;
    font-weight: 500;
    color: #374151;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.position-cards-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
}

.position-card {
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    padding: 16px 12px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #fff;
}

.position-card:hover {
    border-color: #1AA179;
}

.position-card--active {
    border-color: #1AA179;
    background: #e6f9f1;
}

.position-card-icon {
    font-size: 1.2rem;
    color: #6b7280;
    margin-bottom: 8px;
}

.position-card--active .position-card-icon {
    color: #1AA179;
}

.position-card-title {
    font-size: 0.85rem;
    font-weight: 600;
    color: #111827;
    margin-bottom: 4px;
}

.position-card-desc {
    font-size: 0.72rem;
    color: #9ca3af;
}

.input-group-text {
    background-color: #f8f9fa !important;
    border-color: #dee2e6 !important;
    font-size: 14px;
}

.form-control:focus {
    border-color: #1AA179;
    box-shadow: 0 0 0 0.2rem rgba(26, 161, 121, 0.25);
}

.competitor-section {
    margin-top: 8px;
}

.competitor-badge {
    display: inline-block;
    background: #1AA179;
    color: #fff;
    font-size: 0.82rem;
    font-weight: 600;
    padding: 6px 14px;
    border-radius: 999px;
}

.internal-competitor-section {
    border-top: 1px solid #e5e7eb;
    padding-top: 16px;
}

.btn-success {
    background-color: #1AA179 !important;
    border-color: #1AA179 !important;
}

.btn-success:hover:not(:disabled) {
    background-color: #158a65 !important;
    border-color: #158a65 !important;
}

.btn-success:disabled {
    opacity: 0.65;
}
</style>
